/** 7R Decision — overview landing + drill-down sub-pages. */

export const DECISION_FLOWS = [
  { id: "overview", label: "Overview" },
  { id: "why", label: "WHY & inputs" },
  { id: "scores", label: "Score contract" },
  { id: "lenses", label: "7C / 7S" },
  { id: "dependencies", label: "Dependencies" },
  { id: "alternatives", label: "7R alternatives" },
  { id: "explain", label: "Evidence" },
  { id: "authorize", label: "Seal MDR" },
];

export const DECISION_DRILL = DECISION_FLOWS.filter((f) => f.id !== "overview");

export const DECISION_FOCUS_DETAIL = {
  overview: "Recommendation, MDR status and drill-down — one topic per screen.",
  why: "Business intent, rationalization and destination-neutral target context.",
  scores: "Suitability, eligibility, confidence and authorization contract.",
  lenses: "7C and 7S lenses fed by evidence — not themselves a recommendation.",
  dependencies: "Coupling and unknown owners that change 7R ranking.",
  alternatives: "All 7R strategies scored — click a row for hypothesis evidence.",
  explain: "Supporting and constraint facts behind the ranking.",
  authorize: "Immutable MDR seal — human decision authority only.",
};

export const DECISION_FOCUS_TITLE = {
  overview: "7R decision at a glance",
  why: "WHY & decision inputs",
  scores: "Score contract",
  lenses: "7C / 7S lenses",
  dependencies: "Dependency coupling",
  alternatives: "7R alternatives",
  explain: "Explainable decision",
  authorize: "Human authorization",
};

/** Legacy ?focus= values from older 3-pane layout. */
export function resolveDecisionFocus(explicit) {
  if (!explicit) return "overview";
  const legacy = {
    verdict: "overview",
    compare: "alternatives",
    deps: "dependencies",
    alternatives: "alternatives",
  };
  return legacy[explicit] || explicit;
}
